// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    display: flex;
    height: 100vh;
    width: 100%;
    position: relative;
}

.navbar {
    width: 180px;
    height: 100%;
    background-color: #111827;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 20px 0;
    position: fixed;
    left: 0;
    top: 0;
    transition: transform 0.3s ease-in-out;
    z-index: 1000;
}

.navbar.mobile-hidden {
    transform: translateX(-100%);
}

.navbar-logo {
    padding: 0 20px;
    margin-bottom: 40px;
}

.navbar-logo img {
    max-width: 100%;
}

.nav-buttons {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 20px;
}

.nav-button {
    padding: 12px 20px;
    border: none;
    background: none;
    color: #ffffff;
    text-align: left;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.3s;
}

.nav-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.nav-button.active {
    background-color: #40f2cb;
    color: #111827;
}

.nav-button h6 {
    margin: 0;
    padding-top: 2px;
}

.logout-button {
    padding: 20px;
    margin-top: auto;
    margin-bottom: 20px;
}

.main-content {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
    margin-left: 180px;
    transition: margin-left 0.3s ease-in-out;
}

.main-content.mobile-expanded {
    margin-left: 0;
}

.mobile-nav-toggle {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
    font-size: 36px;
    padding-right: 8px;
    padding-bottom: 4px;
    border-radius: 50%;
    background-color: #40f2cb;
    color: #111827;
    border: none;
    cursor: pointer;
    z-index: 1001;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
    .mobile-nav-toggle {
        display: block;
    }

    .main-content {
        margin-left: 0;
    }
} 

.overview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.content-header {
    margin-bottom: 20px;
}

.overview-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    flex-wrap: wrap;
    gap: 20px;
}

.overview-content-item {
    width: 240px;
    height: auto;
    padding: 8px;
    border-radius: 10px;
    border: 2px solid #111827;
    text-align: center;
    box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.2);
}
.overview-content-item h4 {
    margin: 0;
}

.overview-content-item p {
    margin: 0;
}

@media (max-width: 587px) {
    .overview-content-item {
        width: 100%;
    }
}

.overview-content-item h1 { 
    font-size: 54px;
    margin: 0px 0px 10px 0px !important;
}

.overview-content-item h4 {
    margin: 0px !important;
}

.modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    inset: 0;
    background-color: #ffffff;
    padding-bottom: 20px;
    border-radius: 10px;
}

.modal-container {
    background-color: #ffffff;
    box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.2);
    padding: 12px;
    border-radius: 10px;
    width: 100%;
    max-width: 380px;
}

.chart-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    gap: 20px;
}

.chart-content-item h1 {
    margin: 0;
}

.tutorials-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    padding: 2rem;
}

.tutorial-card img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 1rem 0;
}

.video-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #111827;
    color: #ffffff;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    max-width: 90%;
    width: 800px;
}

.video-modal iframe {
    width: 100%;
    height: 450px;
    border: none;
}
  
@media (min-width: 1024px) {
    .tutorials-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .tutorials-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .tutorials-grid {
        grid-template-columns: 1fr;
    }
} 

.settings-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 2rem;
}

.settings-card-actions {
    display: flex;
    gap: 10px;
}
  
.activities-table {
    width: 100%;
    margin-top: 20px;
    border: 2px solid #111827;
    border-radius: 4px;
}

.activities-table th {
    padding: 12px;
    text-align: left;
    background-color: #111827;
    color: #ffffff;
    border-radius: 2px;
}

.activities-table td {
    padding: 12px;
    text-align: left;
}

.activities-table tbody {
    border-radius: 10px;
}


`, "",{"version":3,"sources":["webpack://./src/assets/dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,OAAO;IACP,MAAM;IACN,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;AAChD;AACA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".dashboard-container {\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    position: relative;\n}\n\n.navbar {\n    width: 180px;\n    height: 100%;\n    background-color: #111827;\n    color: #ffffff;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 0;\n    position: fixed;\n    left: 0;\n    top: 0;\n    transition: transform 0.3s ease-in-out;\n    z-index: 1000;\n}\n\n.navbar.mobile-hidden {\n    transform: translateX(-100%);\n}\n\n.navbar-logo {\n    padding: 0 20px;\n    margin-bottom: 40px;\n}\n\n.navbar-logo img {\n    max-width: 100%;\n}\n\n.nav-buttons {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 0 20px;\n}\n\n.nav-button {\n    padding: 12px 20px;\n    border: none;\n    background: none;\n    color: #ffffff;\n    text-align: left;\n    cursor: pointer;\n    border-radius: 4px;\n    transition: background-color 0.3s;\n}\n\n.nav-button:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.nav-button.active {\n    background-color: #40f2cb;\n    color: #111827;\n}\n\n.nav-button h6 {\n    margin: 0;\n    padding-top: 2px;\n}\n\n.logout-button {\n    padding: 20px;\n    margin-top: auto;\n    margin-bottom: 20px;\n}\n\n.main-content {\n    flex: 1;\n    padding: 20px;\n    overflow-y: auto;\n    margin-left: 180px;\n    transition: margin-left 0.3s ease-in-out;\n}\n\n.main-content.mobile-expanded {\n    margin-left: 0;\n}\n\n.mobile-nav-toggle {\n    display: none;\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    font-size: 36px;\n    padding-right: 8px;\n    padding-bottom: 4px;\n    border-radius: 50%;\n    background-color: #40f2cb;\n    color: #111827;\n    border: none;\n    cursor: pointer;\n    z-index: 1001;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n@media (max-width: 768px) {\n    .mobile-nav-toggle {\n        display: block;\n    }\n\n    .main-content {\n        margin-left: 0;\n    }\n} \n\n.overview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n}\n\n.content-header {\n    margin-bottom: 20px;\n}\n\n.overview-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n    flex-wrap: wrap;\n    gap: 20px;\n}\n\n.overview-content-item {\n    width: 240px;\n    height: auto;\n    padding: 8px;\n    border-radius: 10px;\n    border: 2px solid #111827;\n    text-align: center;\n    box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.2);\n}\n.overview-content-item h4 {\n    margin: 0;\n}\n\n.overview-content-item p {\n    margin: 0;\n}\n\n@media (max-width: 587px) {\n    .overview-content-item {\n        width: 100%;\n    }\n}\n\n.overview-content-item h1 { \n    font-size: 54px;\n    margin: 0px 0px 10px 0px !important;\n}\n\n.overview-content-item h4 {\n    margin: 0px !important;\n}\n\n.modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    inset: 0;\n    background-color: #ffffff;\n    padding-bottom: 20px;\n    border-radius: 10px;\n}\n\n.modal-container {\n    background-color: #ffffff;\n    box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.2);\n    padding: 12px;\n    border-radius: 10px;\n    width: 100%;\n    max-width: 380px;\n}\n\n.chart-content {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));\n    gap: 20px;\n}\n\n.chart-content-item h1 {\n    margin: 0;\n}\n\n.tutorials-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 2rem;\n    padding: 2rem;\n}\n\n.tutorial-card img {\n    width: 100%;\n    height: auto;\n    border-radius: 4px;\n    margin: 1rem 0;\n}\n\n.video-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #111827;\n    color: #ffffff;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    max-width: 90%;\n    width: 800px;\n}\n\n.video-modal iframe {\n    width: 100%;\n    height: 450px;\n    border: none;\n}\n  \n@media (min-width: 1024px) {\n    .tutorials-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .tutorials-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 480px) {\n    .tutorials-grid {\n        grid-template-columns: 1fr;\n    }\n} \n\n.settings-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 2rem;\n}\n\n.settings-card-actions {\n    display: flex;\n    gap: 10px;\n}\n  \n.activities-table {\n    width: 100%;\n    margin-top: 20px;\n    border: 2px solid #111827;\n    border-radius: 4px;\n}\n\n.activities-table th {\n    padding: 12px;\n    text-align: left;\n    background-color: #111827;\n    color: #ffffff;\n    border-radius: 2px;\n}\n\n.activities-table td {\n    padding: 12px;\n    text-align: left;\n}\n\n.activities-table tbody {\n    border-radius: 10px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
